import { render, staticRenderFns } from "./tool-bar-action.vue?vue&type=template&id=bcd747be&scoped=true&"
import script from "./tool-bar-action.vue?vue&type=script&lang=js&"
export * from "./tool-bar-action.vue?vue&type=script&lang=js&"
import style0 from "./tool-bar-action.vue?vue&type=style&index=0&id=bcd747be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd747be",
  null
  
)

component.options.__file = "tool-bar-action.vue"
export default component.exports